import React, { useState } from 'react';
import { useHistory } from "react-router-dom";
import { Container, Row, Col, Button, Input, Modal, ModalBody, ModalFooter } from 'reactstrap';
import axios from 'axios';
import InputMask from "react-input-mask";
import helpers from "./helpers/Utilities";
import constants from './helpers/Constants';
import './App.css';


function Login() {

    const [cpf, setCPF] = useState('');
    const [senha, setSenha] = useState('');

    const [showMsgErro, setShowMsgErro] = useState(false);
    const toggleMsg = () => setShowMsgErro(!showMsgErro);

    const history = useHistory();

    const handleEntrar = () => {
        if(cpf.length === 14 && !helpers.isEmpty(senha)){
            axios({
                method: 'post',
                url: constants.APIURLGet,
                headers: {
                  'APITOKEN': constants.APIToken
                },
                data: {
                  query: `select * from associado where cpf = '${cpf}' and senha = '${helpers.sha1(senha)}'`
                }
            })
            .then(function (response) {
                if(response.data.length === 0){
                    toggleMsg();
                }
                else{

                    let associado = JSON.stringify(response.data[0]);
                    localStorage.setItem("usuario_logado", associado);

                    let expirado = false;
                    if(response.data[0].validade === null){
                        expirado = true;
                    }
                    else{
                        let validade = helpers.toDateYMD(response.data[0].validade);
                        let today = Date.now();
                        if(validade < today){
                            expirado = true;
                        }
                    }
                    localStorage.setItem("usuario_expirado", (expirado ? "S" : "N"));

                    history.push("/inicio");
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        }
        else{
            toggleMsg();
        }
    };

    return (
        <Container>
            <Modal isOpen={showMsgErro}>
                <ModalBody>
                    CPF/Senha inválidos.
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={toggleMsg}>OK</Button>
                </ModalFooter>
            </Modal>
            <Row>
                <Col className="bg-azul text-center pt-3 mt-5" style={{'borderRadius': '30px 30px 0px 0px'}}>
                    <img src="logo.png" alt="Logo FIKM" style={{'width': '40%'}}></img>
                </Col>
            </Row>
            <Row>
                <Col className="bg-azul h5 text-white pt-3 pb-5 text-center mb-5" style={{'borderRadius': '0px 0px 30px 30px'}}>
                    Bem-vindo à FIKM
                </Col>
            </Row>
            <Row>
                <Col>
                    <InputMask mask="999.999.999-99" value={cpf} onChange={(e) => setCPF(e.target.value)} className="form-control text-center" placeholder="CPF"></InputMask>
                </Col>
            </Row>
            <Row>
                <Col className="mt-3">
                    <Input value={senha} onChange={(e) => setSenha(e.target.value)} className="text-center" type="password" placeholder="SENHA"></Input>
                </Col>
            </Row>
            <Row>
                <Col className="mt-3">
                    <Button onClick={handleEntrar} className="btn btn-block btn-lg btn-primary btn-azul">ENTRAR</Button>
                </Col>
            </Row>
            <Row>
                <Col className="mt-2">
                    <Button href="/esqueci-senha" className="btn btn-block btn-lg btn-outline-primary btn-outline-azul">ESQUECI MINHA SENHA</Button>
                </Col>
            </Row>
            <Row>
                <Col className="mt-2">
                    <Button href="/" className="btn btn-block btn-lg btn-outline-primary btn-outline-azul">VOLTAR</Button>
                </Col>
            </Row>
        </Container>
    );
}

export default Login;
